/**
 * Latest-wins guard for async flows (usable outside React).
 * begin() returns a request id; after newer begin(), isCurrent(oldId) is false.
 */
export function createLatestRequestGuard() {
  let seq = 0;

  return {
    begin() {
      seq += 1;
      return seq;
    },
    isCurrent(requestId) {
      return requestId === seq;
    },
    /** For tests / hard reset */
    reset() {
      seq = 0;
    },
  };
}
